import React from 'react';
import * as S from './HotelInfoLoader.styles';

const HotelInfoLoader = () => {
  return (
    <S.HotelInfoLoader>
      <S.HeaderWithIconWrap>
        <S.HotelInfoHeader></S.HotelInfoHeader>
        <S.ArrowDownWrap>
          <S.ArrowDown></S.ArrowDown>
        </S.ArrowDownWrap>
      </S.HeaderWithIconWrap>

      <S.SpecialDealOuterWrap>
        <S.SpecialDealWrap></S.SpecialDealWrap>
      </S.SpecialDealOuterWrap>

      <S.HotelInfoOuterWrap>
        <S.ImageContainer></S.ImageContainer>
        <S.HotelDetailsWrap>
          <S.HotelNameLoader></S.HotelNameLoader>
          <S.HotelLocationLoader></S.HotelLocationLoader>
          <S.HotelRatingLoader></S.HotelRatingLoader>
        </S.HotelDetailsWrap>
      </S.HotelInfoOuterWrap>

      <S.CheckingOuterWrap>
        <S.CheckinCheckoutWrap>
          <S.CheckInTitle></S.CheckInTitle>
          <S.CheckInDay></S.CheckInDay>
          <S.CheckInTime></S.CheckInTime>
        </S.CheckinCheckoutWrap>

        <S.CheckinCheckoutWrap>
          <S.CheckInTitle></S.CheckInTitle>
          <S.CheckInDay></S.CheckInDay>
          <S.CheckInTime></S.CheckInTime>
        </S.CheckinCheckoutWrap>

        <S.CheckinCheckoutWrap>
          <S.CheckInTitle></S.CheckInTitle>
          <S.CheckInDay></S.CheckInDay>
          <S.CheckInTime></S.CheckInTime>
        </S.CheckinCheckoutWrap>
      </S.CheckingOuterWrap>

      <S.RoomTitleOuterWrap>
        <S.RoomTitleWrap></S.RoomTitleWrap>
      </S.RoomTitleOuterWrap>
      <S.RoomDetailsContainer>
        <S.RoomImage></S.RoomImage>
        <S.RoomDetailsWrap>
          <S.PriceIncludes></S.PriceIncludes>
          <S.FreeAmenities></S.FreeAmenities>
          <S.FreeAmenities></S.FreeAmenities>
          <S.CancellationPolicy></S.CancellationPolicy>
          <S.ViewBooking></S.ViewBooking>
        </S.RoomDetailsWrap>
      </S.RoomDetailsContainer>
    </S.HotelInfoLoader>
  );
};

export default HotelInfoLoader;
